import { useQuery } from '@tanstack/react-query';
import { Link } from '@/lib/router-compat';
import { blogStockQueryOptions } from '@/lib/blogStockQuery';
import copy from '@/data/translations/ro/blog-editorial.json';

export function BlogStockBlock({ slug }: { slug: string }) {
  const { data, isError } = useQuery(blogStockQueryOptions(slug));
  if (isError || !data?.length) return null;
  return (
    <section className="mt-12 border-t border-border pt-8" aria-label={copy.stock_heading}>
      <h2 className="sans-heading text-2xl mb-3">{copy.stock_heading}</h2>
      <p className="text-sm text-muted-foreground mb-6">{copy.stock_note}</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-blog-stock>
        {data.map(row => (
          <Link key={row.id} to={row.href} className="block overflow-hidden rounded-lg border border-border bg-card text-card-foreground" data-blog-stock-id={row.id}>
            <img src={row.photos?.find(photo => /^https:\/\//.test(photo) && !/demo-images|placeholder|picsum/i.test(photo))} alt={`${row.make} ${row.model}`} width={480} height={320} loading="lazy" className="aspect-[3/2] w-full object-cover" />
            <div className="p-4">
              <h3 className="sans-heading text-base break-words">{row.make} {row.model}</h3>
              <p className="text-sm text-muted-foreground mt-1">{row.year} · {row.location_city}</p>
              <p className="font-semibold mt-3">{new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 }).format(row.eurPrice)} EUR</p>
              <p className="text-xs text-muted-foreground">{copy.stock_price}</p>
            </div>
          </Link>
        ))}
      </div>
      {data.some(row => row.currency.toUpperCase() !== 'EUR') && <p className="text-xs text-muted-foreground mt-3">{copy.stock_conversion}</p>}
    </section>
  );
}